import Login from "./pages/Login.vue";
export default [
    {
        path: '/login',
        name: 'login',
        component: Login
    },
]